var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"skf-header"},[_c('h1',{staticClass:"skf-header__title"},[_vm._v("Sticky Fingers")]),_c('div',{staticClass:"skf-header__links"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/history"}},[_vm._v("History")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }